module.exports = "<div class=\"comp-overlay-full\">\r\n  <div class=\"comp-overlay-full-container\">\r\n    <span class=\"fa fa-spinner fa-2x fa-spin\"></span>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader/loader.component.html
// module id = ./src/app/shared/components/loader/loader.component.html
// module chunks = main